module.exports = __webpack_public_path__ + "media/svgs/TAFA20-Webseite_dropdown_red-5f53637a87a622b9977264ecae1cb98b.svg";